/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';

/**
 *
 * @param {Object} selected
 * @returns
 */
export default function FilterTag({ tag, onClick, selected }) {
  return (
    <Box
      onClick={onClick}
      cursor="pointer"
      // width={{ base: "151px" }}
      bg="black"
      // height="191px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      mb={4} // Add margin bottom for spacing between tags
      mx={{ base: 3, md: 2 }} // Add margin horizontally between tags
    >
      <Box
        width={{ base: '80px', md: '150px' }}
        height={{ base: '80px', md: '150px' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
        borderRadius="50%"
        border={selected ? '5px solid #FEFAF6' : 'none'} // Add border conditionally
      >
        <LazyLoadImageComponent
          src={tag?.filterThumbnail?.url}
          objectFit="cover"
        />
      </Box>
      <Text
        letterSpacing="2%"
        lineHeight="1.8rem"
        fontSize={{ base: '14px', md: '1.125rem' }}
        fontWeight={500}
        textAlign="center"
        textColor="white"
        whiteSpace="nowrap"
        fontFamily="var(--FedraSansStd-book)"
        mt={2}
      >
        {tag.tagName}
      </Text>
    </Box>
  );
}
